/**
 * Pour un popover qui peut manquer de place sous (ou au-dessus de) son déclencheur : il
 * remonte (ou descend) d'autant, quitte à le recouvrir, et ne défile que s'il est plus haut
 * que l'écran. À combiner avec `collisionPadding={8}`.
 */
export const POPOVER_FIT_VIEWPORT = 'max-h-[calc(100dvh-16px)] overflow-y-auto data-[side=bottom]:translate-y-[min(0px,calc(var(--radix-popover-content-available-height)-100%))] data-[side=top]:translate-y-[max(0px,calc(100%-var(--radix-popover-content-available-height)))]';
